import { put, call, select } from 'redux-saga/effects';
import { showNotificationInfo } from '../../modules/notifications/actions';
import get from 'lodash/get';
import { reset, stopSubmit } from 'redux-form';
import { MFA_SETUP_VERIFICATION_FORM } from '../../modules/auth/components/MfaPanel/constants';
import showErrorMessage from '../showErrorMessage';
import { getUserId } from '../../modules/auth/selectors';
import { getUpdatedUserRequest } from '../../modules/menu/actions';
import { closeModal } from '../../components/TP-UI/TPModal/actions';
import { cleanupVerificationInfo } from '../../modules/auth/components/MfaPanel/actions';

export function* showSetupMfaErrorMessage(action) {
  const message = get(action, 'error.data.message', { key: 'auth:mfa.notifications.enable.error' });
  yield put(
    stopSubmit(MFA_SETUP_VERIFICATION_FORM, {
      _error: message,
    }),
  );
}

export function* showSetupPhoneNumberSuccessMessage() {
  yield put(
    showNotificationInfo({
      key: 'auth:mfa.notifications.setupPhone.success',
    }),
  );
  yield put(
    showNotificationInfo({
      key: 'auth:mfa.notifications.sendCode.success',
    }),
  );
}

export function* showSetupPhoneNumberErrorMessage(action) {
  const message = get(action, 'error.data.message', {
    key: 'auth:mfa.notifications.setupPhone.error',
  });
  yield put(
    stopSubmit(MFA_SETUP_VERIFICATION_FORM, {
      _error: message,
    }),
  );
}

export function* showSendSmsVerificationSuccessMessage() {
  yield put(
    showNotificationInfo({
      key: 'auth:mfa.notifications.sendCode.success',
    }),
  );
}

export function* showSendSmsVerificationErrorMessage(action) {
  yield call(showErrorMessage, action);
}

export function* showValidateMfaErrorMessage(action) {
  const message = get(action, 'error.data.message');
  yield put(
    stopSubmit(MFA_SETUP_VERIFICATION_FORM, {
      _error: message,
    }),
  );
}

export function* showChangeMfaErrorMessage(action) {
  yield call(showErrorMessage, action);
}

export function* showChangeMfaSuccessMessage() {
  yield put(
    showNotificationInfo({
      key: 'auth:mfa.notifications.change.success',
    }),
  );
}

export function* setUpdatesAfterChangeMfaSuccess({ form, modal }) {
  const userId = yield select(getUserId);
  yield put(getUpdatedUserRequest(userId));
  yield call(showChangeMfaSuccessMessage);
  yield put(reset(form));
  yield put(closeModal(modal));
  yield put(cleanupVerificationInfo());
}

export function* setUpdatesAfterSetupMfaSuccess({ form, modal }) {
  const userId = yield select(getUserId);
  yield put(getUpdatedUserRequest(userId));
  yield put(
    showNotificationInfo({
      key: 'auth:mfa.notifications.enable.success',
    }),
  );
  yield put(reset(form));
  yield put(closeModal(modal));
}
